
import React, { useState } from 'react'
import { decodeToken } from 'react-jwt'
// import { useSelector } from 'react-redux'
import { useLoggedInUser } from '../../../../Hooks'
import authenticationService from '../../../../Services/authenticationService'
import polacLogo from '../../../../Assets/images/logo.png'
import pscLogo from '../../../../Assets/images/psc1_logo.png'
import './Login.scss'
import toast, { Toaster } from 'react-hot-toast'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { MakeRand } from '../../../../Hooks/MakeRand'
import { useAuth } from '../../../../Components/AuthProvider/AuthProvider'
// import verificationService from '../../../../Services/verificationService'

type Inputs = {
  username: string,
  password: string,
};

const Login = () => {
  const userObject = useLoggedInUser()
  const navigate = useNavigate()
  const [submit, setSubmit] = useState<boolean>(false)
  const [lock, setLock] = useState(false)
  const { login } = useAuth()

  //   const session = useSelector((state: { session: boolean; }) => state.session)

  const { register, handleSubmit, formState: { errors } } = useForm<Inputs>()

  const onSubmit = handleSubmit((data:any) => processLogin(data))

  const processLogin = async (data:{username: string, password: string}) => {
    setSubmit(true)

    const randCode = MakeRand(32)
    await authenticationService.loginUserApi({
      ...data,
      _trojan_token: randCode,
      usertype: 'cpanel',
      pattern: 'tier-3',
      deviceId: 'trojan'
    }).then((user:any) => {
      // console.log('user', user)
      const myDecodedToken:any = decodeToken(user.data?.token)

      localStorage.setItem('__userRole', myDecodedToken.mainRole)
      // const me = localStorage.getItem('__userRole')
      // console.log('meeeeee', me)
      // console.log('User details', { ...myDecodedToken, ...user.data })
      console.log('User details 00000', myDecodedToken)

      if (myDecodedToken.mainRole !== 'pscreen_academic_officer' && myDecodedToken.mainRole !== 'pscreen_officer') {
        toast.error('Access denied, Unauthorized user role.', { duration: 20000, className: 'bg-danger text-white' })
        setSubmit(false)
        return 0
      }

      if (myDecodedToken.lockStatus === 'lock') {
        setLock(true)
      } else {
        localStorage.setItem('__session_polac_physical', JSON.stringify({ ...myDecodedToken, ...user.data }))
        login({ ...myDecodedToken, ...user.data })
        return navigate('/dashboard', { replace: true })
      }
      // else if (myDecodedToken.mainRole === 'pscreen_academic_officer') {
      //   localStorage.setItem('__session_polac_physical', JSON.stringify({ ...myDecodedToken, ...user.data }))
      //   login({ ...myDecodedToken, ...user.data })
      //   return navigate('/', { replace: true })
      // }
    }, (error:any) => {
      console.log('error.message', error.message)
      console.log('error.response', error.response)
      toast.error(error.message, { duration: 20000, className: 'bg-danger text-white' })
      setSubmit(false)
    })
  }

  if (userObject !== null) {
    window.location.replace('/dashboard')
  }

  return (
        <div className="login-container">
            <div className="login-wrapper">
                {/* Left Side - Login Form */}
                <div className="login-form-section">
                    <div className="form-content">
                        <h1 className="welcome-title">Welcome Back</h1>
                        <p className="welcome-subtitle">Sign in :</p>

                        <form onSubmit={onSubmit}>
                            {lock && (
                                <div className="alert alert-danger text-center mb-4">
                                    Account locked please contact admin.
                                </div>
                            )}

                            <div className="form-group mb-4">
                                <label className="form-label">Email Address</label>
                                <div className="input-wrapper">
                                    <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                        <polyline points="22,6 12,13 2,6"/>
                                    </svg>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                                        placeholder="psc@psc.gov.ng"
                                        {...register('username', { required: 'field cannot be empty' })}
                                    />
                                </div>
                                {errors.username && <div className="text-danger mt-1">{errors.username.message}</div>}
                            </div>

                            <div className="form-group mb-4">
                                <label className="form-label">Password</label>
                                <div className="input-wrapper">
                                    <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                    </svg>
                                    <input
                                        type="password"
                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                        placeholder="••••••••••"
                                        {...register('password', { required: 'field cannot be empty' })}
                                    />
                                    <button type="button" className="password-toggle">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                            <circle cx="12" cy="12" r="3"/>
                                        </svg>
                                    </button>
                                </div>
                                {errors.password && <div className="text-danger mt-1">{errors.password.message}</div>}
                            </div>

                            <div className="remember-me-section mb-4">
                                <input type="checkbox" id="remember" className="remember-checkbox"/>
                                <label htmlFor="remember" className="remember-label">Remember me</label>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-signin w-100"
                                disabled={submit}
                            >
                                {submit
                                  ? (
                                    <>
                                        Authenticating...
                                        <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                    </>
                                    )
                                  : (
                                      'Sign In'
                                    )}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Right Side - Branding */}
                <div className="login-branding-section">
                    <div className="branding-content">
                        <div className="logos-container">
                            <img src={pscLogo} alt="PSC Logo" className="brand-logo"/>
                            <img src={polacLogo} alt="Police Logo" className="brand-logo"/>
                        </div>

                        <h1 className="brand-title">PSC-NPF Recruitment</h1>
                        {/* <h2 className="brand-subtitle">Admin Portal</h2> */}
                        <h2 className="brand-module">Physical / Credentials Screening Module</h2>

                        <div className="brand-divider"></div>

                        <ul className="features-list">
                            <li>
                                <span className="bullet"></span>
                                Secure Field Operator module
                            </li>
                            <li>
                                <span className="bullet"></span>
                                Manage Nigeria Police Recruitment Candidate credentials and physical screening exercise
                            </li>
                        </ul>

                        <p className="brand-footer">Police Service Commission • Nigeria Police Force</p>
                    </div>
                </div>
            </div>
            <Toaster/>
        </div>
  )
}

export default Login
